import React from "react";
import PropTypes from "prop-types";

const ModuleSideHalf = ({ children, className }) => {
  return (
    <div
      className={`h-1/2 lg:h-full w-full lg:w-1/2 flex items-center justify-center ${
        className && className
      }`}
    >
      {children}
    </div>
  );
};

ModuleSideHalf.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};

export default ModuleSideHalf;
